export default __webpack_public_path__ + "locales/nl/PrivacyPage.json?hash=a01e3c1b775707d38cbabc600f06063c";